<template>
  <div id="details-app-page" class="main-page">
    <div class="container" v-if="complete">
      <p class="app-page-title">Summary</p>

      <div class="app-section">
        <p class="app-section-title">User</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">User Information</td>
            </tr>
            <tr>
              <td>Full name</td>
              <td>{{detail.fullname}}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{detail.app_user}}</td>
            </tr>
            <tr>
              <td>Application type</td>
              <td>{{detail.app_name}}</td>
            </tr>
            <tr>
              <td>Application ID</td>
              <td>{{detail.uid}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Business</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Business Owner</td>
            </tr>
            <tr>
              <td>First Name</td>
              <td>{{detail.business_owner.first_name || '-'}}</td>
            </tr>
            <tr>
              <td>Last Name</td>
              <td>{{detail.business_owner.last_name || '-'}}</td>
            </tr>
            <tr>
              <td>Position</td>
              <td>{{detail.business_owner.position || '-'}}</td>
            </tr>
            <tr>
              <td>Cell Phone</td>
              <td>{{detail.business_owner.cell_phone || '-'}}</td>
            </tr>
            <tr>
              <td>Work Phone</td>
              <td>{{detail.business_owner.work_phone || '-'}}</td>
            </tr>
            <tr>
              <td>Fax Phone</td>
              <td>{{detail.business_owner.fax_phone || '-'}}</td>
            </tr>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Company Information</td>
            </tr>
            <tr>
              <td>Merchant's Legal Business Name</td>
              <td>{{detail.company.legal_company_name || '-'}}</td>
            </tr>
            <tr>
              <td>Corporation Type</td>
              <td>{{detail.company.company_corporate_type_name || '-'}}</td>
            </tr>
            <tr>
              <td>Company Start Date</td>
              <td>{{detail.company.company_start_date || '-'}}</td>
            </tr>
            <tr>
              <td>Tax ID / EIN</td>
              <td>{{detail.company.tax_id}}</td>
            </tr>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Business Information</td>
            </tr>
            <tr>
              <td>What Type of Business Are You In? Do Not Say Sales</td>
              <td>{{detail.company.company_business_type || '-'}}</td>
            </tr>
            <tr>
              <td>Business Website</td>
              <td>{{detail.company.company_web}}</td>
            </tr>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Your Business Transaction Details</td>
            </tr>
            <tr>
              <td>Estimated Monthly Volume</td>
              <td>${{detail.company.estimated_monthly_volume || '-'}}</td>
            </tr>
            <tr>
              <td>Estimated Low Check Amount</td>
              <td>${{detail.company.estimated_low_check_amount || '-'}}</td>
            </tr>
            <tr>
              <td>Estimated High Check Amount</td>
              <td>${{detail.company.estimated_high_check_amount || '-'}}</td>
            </tr>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Business Address</td>
            </tr>
            <tr>
              <td>Street Address</td>
              <td>{{detail.company.company_address || '-'}}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{{detail.company.company_city || '-'}}</td>
            </tr>
            <tr>
              <td>State</td>
              <td>{{detail.company.company_state_name || '-'}}</td>
            </tr>
            <tr>
              <td>Zip / Postal Code</td>
              <td>{{detail.company.company_zip_portal || '-'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Bank Info</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Ownership Information</td>
            </tr>
            <tr>
              <td>Owner Name</td>
              <td>{{detail.business_owner.owner_fullname || '-'}}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{detail.business_owner.email || '-'}}</td>
            </tr>
            <tr>
              <td>Title</td>
              <td>{{detail.business_owner.title || '-'}}</td>
            </tr>
            <tr>
              <td>SSN</td>
              <td>{{detail.business_owner.ssn || '-'}}</td>
            </tr>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Bank Account Information (For Deposits)</td>
            </tr>
            <tr>
              <td>Bank/Financial Institution Name</td>
              <td>{{detail.bank_detail.bank_name || '-'}}</td>
            </tr>
            <tr>
              <td>Routing #</td>
              <td>{{detail.bank_detail.routing || '-'}}</td>
            </tr>
            <tr>
              <td>Account #</td>
              <td>{{detail.bank_detail.account || '-'}}</td>
            </tr>
            <tr>
              <td>Address on Bank Account</td>
              <td>{{detail.bank_detail.bank_address || '-'}}</td>
            </tr>
            <tr>
              <td>State</td>
              <td>{{detail.bank_detail.bank_state_name || '-'}}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{{detail.bank_detail.bank_city || '-'}}</td>
            </tr>
            <tr>
              <td>Zip / Postal Code</td>
              <td>{{detail.bank_detail.bank_zip || '-'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Credit Card Info</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Bank Credit and Debit Card Information</td>
            </tr>
            <tr>
              <td>Name on the Card</td>
              <td>{{detail.card.card_name || '-'}}</td>
            </tr>
            <tr>
              <td>Billing Address For the Card</td>
              <td>{{detail.card.billing_address || '-'}}</td>
            </tr>
            <tr>
              <td>State</td>
              <td>{{detail.card.billing_state_name || '-'}}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{{detail.card.billing_city || '-'}}</td>
            </tr>
            <tr>
              <td>Zip / Postal Code</td>
              <td>{{detail.card.billing_zip || '-'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Documentation</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Supporting Documents</td>
            </tr>
            <tr>
              <td>Drivers License</td>
              <td>
                <a
                  v-if="detail.document_driver_license"
                  :href="detail.document_driver_license"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
            <tr>
              <td>Voided Check</td>
              <td>
                <a
                  v-if="detail.document_Voided_Check"
                  :href="detail.document_Voided_Check"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
            <tr>
              <td>Articles of Incorporation</td>
              <td>
                <a
                  v-if="detail.document_Articles_of_Incorporation"
                  :href="detail.document_Articles_of_Incorporation"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
            <tr>
              <td>(4) Months of Bank Statements</td>
              <td>
                <a
                  v-if="detail.document_Months_of_Bank_Statements"
                  :href="detail.document_Months_of_Bank_Statements"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
            <tr>
              <td>(4) Months of Processing Statements</td>
              <td>
                <a
                  v-if="detail.document_Months_of_Processing_Statements"
                  :href="detail.document_Months_of_Processing_Statements"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["param"],
  data: () => {
    return {
      detail: [],
      complete: false
    };
  },
  mounted() {
    this.$store
      .dispatch("get_app_detail", this.param)
      .then(res => {
        this.detail = res.data;
        this.complete = true;
      })
      .catch(err => {});
  }
};
</script>

<style>
</style>